const globalAreas = new Set([
  "admin",
  "organisations",
  "login",
  "forgot-password",
])

export function signInPath(pathname: string): string {
  const [, organisation, area] = pathname.split("/")

  if (!organisation || globalAreas.has(organisation)) {
    return "/login"
  }

  return area === "portal"
    ? `/${organisation}/portal/login`
    : `/${organisation}/login`
}
